import { render, staticRenderFns } from "./ChangeTypeView.vue?vue&type=template&id=707d18dc&"
import script from "./ChangeTypeView.vue?vue&type=script&lang=js&"
export * from "./ChangeTypeView.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTypeView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports